import request, { getLatLng } from './request';
import { ActivityConfig, ActivityRes } from './types';

export const fetchActivity = (config: ActivityConfig) => {
  const loc = getLatLng();
  return request<ActivityRes>({
    url: 'v1/channel/activity/list',
    method: 'POST',
    data: {
      longitude: loc.longitude,
      latitude: loc.latitude,
      homePageLatitude: loc.actualLatitude,
      homePageLongitude: loc.actualLongitude,
      poiId: '',
      channelId: config.channelId,
    },
    fingerprint: true,
  });
};

export const fetchDspData = () => {
  const loc = getLatLng();
  return request<ActivityRes>({
    url: 'v1/channel/launch/task/list',
    method: 'POST',
    data: {
      commonChannelId: 'one-person-pop-10001',
      longitude: loc?.actualLongitude,
      latitude: loc?.actualLatitude,
      homePageLatitude: loc?.latitude,
      homePageLongitude: loc?.longitude,
      fingerPrint: true,
    },
  });
};
